import { useRouteError, Link, isRouteErrorResponse } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  let title = "Oops! Something went wrong";
  let message = "An unexpected error has occurred.";

  if (isRouteErrorResponse(error)) {
    // React Router specific errors (404, 401, etc.)
    title = `${error.status} - ${error.statusText}`;
    message = error.data?.message || message;
  } else if (error instanceof Error) {
    // JS runtime error
    message = error.message;
  }

  return (
    <div className="container pt-5 mt-5 text-center">
      <h1>{title}</h1>
      <p>{message}</p>

      <Link to="/" className="btn btn-light rounded-pill px-4 py-2">
        Go back to Home
      </Link>
    </div>
  );
}
